// extracted by mini-css-extract-plugin
export default {"container":"bottom-bar_container__rn51+","inner":"bottom-bar_inner__TT35r","left":"bottom-bar_left__W+lig","right":"bottom-bar_right__DIinP"};